import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartphoneLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 9.2382813,2.25 c -2.4118576,0 -4.3691407,1.956573 -4.3691407,4.3691406 l 0.00195,10.7636714 c 3e-5,2.411598 1.95549,4.367188 4.3671876,4.367188 h 5.5156248 c 2.412698,0 4.367188,-1.956443 4.367188,-4.369141 V 6.6171875 C 19.121094,4.2054899 17.165604,2.25 14.753906,2.25 Z m 0,1.5 h 5.5156247 c 1.583299,0 2.867188,1.2838891 2.867188,2.8671875 V 17.380859 c 0,1.584199 -1.282889,2.869141 -2.867188,2.869141 H 9.2382813 c -1.5833085,0 -2.8671875,-1.283889 -2.8671876,-2.867188 L 6.3691406,6.6191406 C 6.3691806,5.0347622 7.6551428,3.75 9.2382813,3.75 Z m 2.7578127,12.529297 c -0.5515,0 -1,0.4471 -1,1 0,0.552399 0.4476,1 1,1 0.552499,0 1,-0.447601 1,-1 0,-0.5529 -0.448401,-1 -1,-1 z"
	})]
});
export default SvgSmartphoneLine;
